<script setup lang="ts">

import { ref } from "vue"

import useUpdatePWA from "../../composables/tools/UpdatePWAComposable";
// @ts-ignore
import { ElNotification } from 'element-plus';

const activeBanner = ref(false);
const PWAUpdateComposable = useUpdatePWA();

const updatePWA = () => {
	PWAUpdateComposable.refreshApp();
	ElNotification({
		title: 'Mise à jour',
		message: 'La mise à jour a été installée avec succès',
		type: 'success'
	})
}

</script>

<template>

	<transition name="fade-up-in" appear>

		<div v-if="PWAUpdateComposable.updateExists.value" class="pwa-banner" :class="[{ activeBanner }]">

			<div class="install__button">
				Une mise à jour est disponible !
			</div>

			<a class="btn__download" @click="updatePWA">
				<svg version="1.1" width="700px" height="700px" viewBox="0,0,256,256">
					<g fill-rule="nonzero" stroke="none" stroke-width="1" stroke-linecap="butt" stroke-linejoin="miter"
						stroke-miterlimit="10" stroke-dasharray="" stroke-dashoffset="0" font-family="none"
						font-weight="none" font-size="none" text-anchor="none" style="mix-blend-mode: normal">
						<g transform="scale(8,8)">
							<path
								d="M15,4v16.5625l-5.28125,-5.28125l-1.4375,1.4375l7,7l0.71875,0.6875l0.71875,-0.6875l7,-7l-1.4375,-1.4375l-5.28125,5.28125v-16.5625zM7,26v2h18v-2z">
							</path>
						</g>
					</g>
				</svg>
				<span>{{ $t('common.install') }}</span>
			</a>

			<button class="close__button">
				<span aria-hidden="true">×</span>
				<span class="sr">Close</span>
			</button>
		</div>
	</transition>
</template>

<style scoped lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap");

.btn__download {
	font-size: inherit;
	margin: 0 0 0 0.5rem;
	padding: 0.25em 0.5em;
	padding-left: 1rem;
	padding-right: 1rem;
	padding-top: 0.625rem;
	padding-bottom: 0.625rem;
	cursor: pointer;
	/* rounded corner overflow mask fix */
	overflow: hidden;
	border-radius: 5px;
	-webkit-box-sizing: border-box;
	-moz-box-sizing: border-box;
	box-sizing: border-box;
	background: #8e44ad;
	border: 1px solid white;
	color: white;
	padding: 15px 0 15px 28px;
	width: 180px;
	display: inline-block;
	position: relative;
	-webkit-transition: all 300ms ease;
	-moz-transition: all 300ms ease;
	transition: all 300ms ease;
	margin-right: -25px;
}

.btn__download span:after,
.btn__download span:before {
	content: "";
	width: 1px;
	height: 16px;
	background: #604dff;
	opacity: 0;
	position: absolute;
	left: 50%;
	top: 100%;
	-webkit-transition: all 10ms ease-out;
	-moz-transition: all 10ms ease-out;
	transition: all 10ms ease-out;
	-webkit-transform-origin: center bottom;
	-moz-transform-origin: center bottom;
	-ms-transform-origin: center bottom;
	-o-transform-origin: center bottom;
	transform-origin: center bottom;
	-webkit-transform: translateY(0) rotate(0deg);
	-moz-transform: translateY(0) rotate(0deg);
	-ms-transform: translateY(0) rotate(0deg);
	-o-transform: translateY(0) rotate(0deg);
	transform: translateY(0) rotate(0deg);
	-webkit-animation: 0;
	-moz-animation: 0;
	animation: 0;
}

.btn__download svg {
	z-index: 0;
	fill: white;
	position: absolute;
	left: 20%;
	top: 50%;
	-webkit-transform: translate(-50%, -50%) rotate(0deg) scale(0.04857);
	-moz-transform: translate(-50%, -50%) rotate(0deg) scale(0.04857);
	-ms-transform: translate(-50%, -50%) rotate(0deg) scale(0.04857);
	-o-transform: translate(-50%, -50%) rotate(0deg) scale(0.04857);
	transform: translate(-50%, -50%) rotate(0deg) scale(0.04857);
	-webkit-transition: all 350ms ease-out;
	-moz-transition: all 350ms ease-out;
	transition: all 350ms ease-out;
	height: 700px;
}

.btn__download:hover {
	background-color: white;
	color: #604dff;
	border: 1px solid #604dff;
}

.btn__download:hover svg {
	fill: #604dff;
}

.pwa-banner {
	cursor: pointer;
	font-family: "Poppins", sans-serif;
	font-size: 1rem;
	z-index: 20;
	line-height: 1;
	bottom: 0;
	left: 0;
	width: 100vw;
	padding: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	height: 2rem;
	background: #9b59b6;
	color: white;
	margin: 0;
	position: fixed;

	.install__button {
		margin: auto;
	}

	.close__button {
		top: -.5rem;
		font-size: 2rem;
		background: transparent;
		border: 0;
		padding: 0 2.75rem;
		height: 100%;
		line-height: 1;
		cursor: pointer;
		color: transparent;
	}

	.sr {
		position: absolute;
		width: 1px;
		height: 1px;
		left: -100vw;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		border: 0;
	}
}

.fade-up-in-enter-active,
.fade-up-in-leave-active {
	transition: opacity 1s cubic-bezier(0.165, 0.84, 0.44, 1), transform 1s cubic-bezier(0.165, 0.84, 0.44, 1);
	transform: translateY(0);
}

.fade-up-in-enter,
.fade-up-in-leave-to {
	opacity: 0;
	transform: translateY(4rem);
}
</style>
